// extracted by mini-css-extract-plugin
module.exports = {"container":"LockOverlay_container__1JonI","blur":"LockOverlay_blur__1a2kV","overlay":"LockOverlay_overlay__3jeQG","icon":"LockOverlay_icon__2U70z"};